{{#if asModalDialog}}
<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{TYPE_METER type}} - {{TR "Einstellungen"}}</h4>
</div>
<div class="modal-body">
{{/if}}
	{{#if errors.error}}
		<div class="alert alert-danger">
			{{TR errors.error}}
			{{#if errors.sysErr}}
			 ({{ERROR_TR errors.sysErr}})
			{{/if}}
		</div>
	{{/if}}
	<div class="row">
		<div class="col-xs-12">
			<div class="form-group">
				<label for="name" class="control-label">{{TR "Gerätename"}}</label>
				<input type="text" class="form-control {{#if errors.name}}parsley-error{{/if}}" id="name-input" name="name" placeholder="{{TR "Gerätename"}}" value="{{formData.name}}" maxlength="100">
				{{#if errors.name}}
				<ul class="parsley-errors-list filled" id="js-name-error">
				<li class="parsley-required">{{TR errors.name}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
	</div>
	<div class="row {{#if asModalDialog}}invisible{{/if}}">
		<div class="col-sm-6">
			<div class="form-group">
				<label for="address" class="control-label">{{TR "M-Bus Primäradresse"}}</label>
				<input type="number" class="form-control {{#if errors.address}}parsley-error{{/if}}" id="address-input" name="address" placeholder="{{TR "M-Bus Adresse"}}" value="{{formData.address}}" min="0" max="254">
				{{#if errors.address}}
				<ul class="parsley-errors-list filled" id="js-address-error">
				<li class="parsley-required">{{TR errors.address}}</li>
				</ul>
				{{/if}}
			</div>
		</div>
{{!--
		Deactivated. Right now, SAMSON does not want to allow to add
		electricity meter devices.
--}}
		<div class="col-sm-6 invisible">
			<label for="type" class="control-label">{{TR "Zählertyp"}}</label><br>
			<div class="row">
				<div class="col-xs-6">
					<div class="radio">
						<input type="radio" id="js-type-wmz" value="wmz" name="type" checked>
						<label for="js-type-wmz">{{TR "Wärmemenge"}}</label>
					</div>
				</div>
				<div class="col-xs-6">
					<div class="radio">
						<input type="radio" id="js-type-ez" value="ez" name="type">
						<label for="js-type-ez">{{TR "Strom"}}</label>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row {{#if asModalDialog}}invisible{{/if}}">
		<div class="col-sm-12">
				<div class="checkbox checkbox-primary">
					<input
						id="js-solvimus-input"
						name="solvimus"
						type="checkbox"
					/>
					<label for="js-solvimus-input">{{TR "Solvimus (Zähler Primäradresse = Modbus Stationsadresse)"}}</label>
				</div>
		</div>
	</div>
{{#if asModalDialog}}
</div>
<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button class="btn btn-primary" id="js-success">{{TR "Speichern"}}</button>
</div>
{{/if}}
